import { StateCode, StateEntity } from "state/types";
import InitialContext from "./InitialContext"

export const AvailableStates: ReadonlyArray<StateEntity> = InitialContext.getAvailableStates();
export const AvailableStatesMap: Record<StateCode, StateEntity> = AvailableStates.reduce((map, v) => {
    (map as any)[v.stateCode] = v;
    return map;
}, {});
export const getState = (stateCode: StateCode | undefined) => {
    return stateCode ? AvailableStatesMap[stateCode] : undefined;
}